// extracted by mini-css-extract-plugin
export default {"apple-button":"AppleButton--apple-button--fZrIp","appleButton":"AppleButton--apple-button--fZrIp"};